import { render, staticRenderFns } from "./readonly.vue?vue&type=template&id=d3dc8f20&"
import script from "./readonly.vue?vue&type=script&lang=js&"
export * from "./readonly.vue?vue&type=script&lang=js&"
import style0 from "./readonly.vue?vue&type=style&index=0&id=d3dc8f20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports